import { AxiosResponse } from 'axios'

import { IServerResponse } from '@/domains/CommonDomain'

import { isNumberFormat, toInteger } from './numberUtils'

class CustomError extends Error {
  code: string | number

  constructor(code: string | number) {
    super()
    this.code = typeof code === 'string' && isNumberFormat(code) ? toInteger(code) : code
  }
}

export function newError(code: string | number) {
  return new CustomError(code)
}

export class ApiError<T> extends Error {
  code: string | number
  content: T

  constructor(response: AxiosResponse<IServerResponse<T>>) {
    const { message, code, content } = response.data

    super(message)

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, ApiError)
    }

    this.code = code
    this.content = content
  }
}
